import { render, staticRenderFns } from "./VGridCell.vue?vue&type=template&id=35ae90d6&scoped=true&"
import script from "./VGridCell.vue?vue&type=script&lang=ts&"
export * from "./VGridCell.vue?vue&type=script&lang=ts&"
import style0 from "./VGridCell.vue?vue&type=style&index=0&id=35ae90d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35ae90d6",
  null
  
)

export default component.exports